import {Injectable} from '@angular/core';
import {State} from '@ngxs/store';
import {LocationPlaceResult} from '../domains/location-place-result';

export interface LocationAutocompleteStateModel {
  loading: boolean;
  locations: LocationPlaceResult[];
}

const defaults: LocationAutocompleteStateModel = {loading: false, locations: []};

@State<LocationAutocompleteStateModel>({
  name: 'locationAutocomplete',
  defaults
})
@Injectable()
export class LocationAutocompleteState {

}
